/* eslint react/prop-types:0 */
import React from 'react';
import PropTypes from 'prop-types';

import { Screen } from '@confluence/screen';
import { TemplateMigrationPreviewLoader } from '@confluence/template-migration-preview';

export const TemplateMigrationPreviewRoute = ({ name, params: { contentId } }) => (
	<Screen
		screenEvent={{ name: 'templateMigrationPreviewScreen' }}
		pageState={{
			routeName: name,
			contentId,
		}}
	>
		<TemplateMigrationPreviewLoader templateId={contentId} />
	</Screen>
);

TemplateMigrationPreviewRoute.propTypes = {
	params: PropTypes.shape({
		contentId: PropTypes.string,
	}),
};
